import * as React from "react";
const SvgCircleMarker = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("circle", {
	cx: 8,
	cy: 8,
	r: 8
}), /* @__PURE__ */ React.createElement("circle", {
	cx: 7.99916,
	cy: 7.99916,
	r: 4.57143,
	fill: "white"
}));
export default SvgCircleMarker;
